// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2whvg","badges":"styles_badges__NV1cV"};